import { getFrontImageUrl } from "../../../../front/staticServerRendering/frontImage";
import { ImageSize } from "../../../../constants/imageSizes";
import { AudioArticlesRecommendationsItem } from "./audioArticlesRecommendationsInterfaces";

export type AudioArticlesRecommendationsAction = "youtube" | "apple" | "spotify" | "share";

export type ProcessedAudioArticlesRecommendationsItem = AudioArticlesRecommendationsItem & {
    categoryIconSrc?: string;
    imageUrl?: string;
};

export function formatDuration(durationInSeconds: number): string {
    if (!durationInSeconds) {
        return "";
    }
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = Math.floor(durationInSeconds % 60);

    return [hours, minutes, seconds].map((value) => value.toString().padStart(2, "0")).join(":");
}

export function resolveImageSrc(imageUrl: string, imagesDomain: string): string {
    const frontImageUrl = imageUrl ? getFrontImageUrl({ publishedLink: imageUrl } as any, { imageSize: ImageSize.medium }) : "";
    if (!frontImageUrl) {
        return "";
    }
    if (frontImageUrl.startsWith("//") || frontImageUrl.startsWith("http")) {
        return frontImageUrl;
    }
    return frontImageUrl.startsWith("/")
        ? imagesDomain + frontImageUrl
        : imagesDomain + "/" + frontImageUrl;
}

const NATIVE_ACTION_HREF: { [key in AudioArticlesRecommendationsAction]: string } = {
    share: "//share",
    youtube: "//share-youtube",
    apple: "//share-apple",
    spotify: "//share-spotify",
};

export function buildNativeActionHref(
    action: AudioArticlesRecommendationsAction,
    itemId: string,
): string {
    const baseHref = NATIVE_ACTION_HREF[action];
    return itemId ? `${baseHref}/${itemId}` : baseHref;
}
